// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/types/gift_shop.proto" (package "mlmbox.types", syntax proto3)
// tslint:disable
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Wallet_Asset_Transaction } from "./wallet.ts";
/**
 * @generated from protobuf message mlmbox.types.GiftShop
 */
export interface GiftShop {
}
/**
 * @generated from protobuf message mlmbox.types.GiftShop.Card
 */
export interface GiftShop_Card {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number; // идентификатор карточки
    /**
     * @generated from protobuf field: string title = 2;
     */
    title: string; // название карточки (лимит 255 символов)
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string; // описание карточки (лимит 950 символов)
    /**
     * @generated from protobuf field: string image_src = 4;
     */
    imageSrc: string; // ссылка на изображение карточки (содержит только путь к файлу основного домена)
    /**
     * @generated from protobuf field: string usdt_price = 5;
     */
    usdtPrice: string; // цена карточки в USDT (при создании и редактировании карточки, необходимо обращать внимание на минимальную цену карточки в settings_card_usdt_price_min)
    /**
     * @generated from protobuf field: string usdt_fee = 6;
     */
    usdtFee: string; // комиссия заложенная за вывод USDT
    /**
     * @generated from protobuf field: string points_needed = 7;
     */
    pointsNeeded: string; // количество баллов необходимых для покупки карточки (если значение points_balance_available более или равно points_needed, то карточка доступна для покупки)
    /**
     * @generated from protobuf field: bool released = 8;
     */
    released: boolean; // куплена ли карточка
    /**
     * @generated from protobuf field: uint32 created_at = 9;
     */
    createdAt: number; // метка времени создания карточки
    /**
     * @generated from protobuf field: uint32 released_at = 10;
     */
    releasedAt: number; // метка времени покупки карточки
    /**
     * @generated from protobuf field: mlmbox.types.Wallet.Asset.Transaction transaction = 11;
     */
    transaction?: Wallet_Asset_Transaction; // транзакция вывода USDT (поле отображается когда запрошен вывод средств, в ином случае поле будет пустым)
    /**
     * @generated from protobuf field: string review_video_url = 12;
     */
    reviewVideoUrl: string; // ссылка на видео отзыв о карточке (допускаются ссылки на видео с youtube и vimeo)
    /**
     * @generated from protobuf field: uint32 review_created_at = 13;
     */
    reviewCreatedAt: number; // дата создания отзыва
    /**
     * @generated from protobuf field: bool review_approved = 14;
     */
    reviewApproved: boolean; // одобрен ли отзыв
}
/**
 * @generated from protobuf message mlmbox.types.GiftShop.Card.Id
 */
export interface GiftShop_Card_Id {
    /**
     * @generated from protobuf field: uint32 id = 1;
     */
    id: number; // идентификатор карточки (используется для обращения к карточке)
}
/**
 * @generated from protobuf message mlmbox.types.GiftShop.Info
 */
export interface GiftShop_Info {
    /**
     * @generated from protobuf field: string points_balance_frozen = 1;
     */
    pointsBalanceFrozen: string; // значение замороженных баллов
    /**
     * @generated from protobuf field: string points_balance_available = 2;
     */
    pointsBalanceAvailable: string; // значение доступных баллов для покупки карточек
    /**
     * @generated from protobuf field: repeated uint32 need_review_card_ids = 3;
     */
    needReviewCardIds: number[]; // идентификаторы карточек, которые ожидают отзыва (появится исключение "GIFT_SHOP_CARD_REVIEW_NEED" если запросить вывод средств при необходимости заполнить отзыв)
    /**
     * @generated from protobuf field: mlmbox.types.GiftShop.Card card = 4;
     */
    card?: GiftShop_Card;
}
/**
 * @generated from protobuf message mlmbox.types.GiftShop.State
 */
export interface GiftShop_State {
    /**
     * @generated from protobuf field: string points_balance_frozen = 1;
     */
    pointsBalanceFrozen: string; // значение замороженных баллов
    /**
     * @generated from protobuf field: string points_balance_available = 2;
     */
    pointsBalanceAvailable: string; // значение доступных баллов для покупки карточек
    /**
     * @generated from protobuf field: string settings_card_usdt_price_min = 3;
     */
    settingsCardUsdtPriceMin: string; // параметр-настройка минимальной цены карточки в USDT (используется на момент создания карточки)
    /**
     * @generated from protobuf field: repeated uint32 need_review_card_ids = 4;
     */
    needReviewCardIds: number[]; // идентификаторы карточек, которые ожидают отзыва (появится исключение "GIFT_SHOP_CARD_REVIEW_NEED" если запросить вывод средств при необходимости заполнить отзыв)
    /**
     * @generated from protobuf field: repeated mlmbox.types.GiftShop.Card cards = 5;
     */
    cards: GiftShop_Card[];
}
// @generated message type with reflection information, may provide speed optimized methods
class GiftShop$Type extends MessageType<GiftShop> {
    constructor() {
        super("mlmbox.types.GiftShop", []);
    }
    create(value?: PartialMessage<GiftShop>): GiftShop {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GiftShop>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftShop): GiftShop {
        return target ?? this.create();
    }
    internalBinaryWrite(message: GiftShop, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GiftShop
 */
export const GiftShop = new GiftShop$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftShop_Card$Type extends MessageType<GiftShop_Card> {
    constructor() {
        super("mlmbox.types.GiftShop.Card", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 2, name: "title", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "image_src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "usdt_price", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "usdt_fee", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "points_needed", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "released", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 10, name: "released_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 11, name: "transaction", kind: "message", T: () => Wallet_Asset_Transaction },
            { no: 12, name: "review_video_url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "review_created_at", kind: "scalar", T: 13 /*ScalarType.UINT32*/ },
            { no: 14, name: "review_approved", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<GiftShop_Card>): GiftShop_Card {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        message.title = "";
        message.description = "";
        message.imageSrc = "";
        message.usdtPrice = "";
        message.usdtFee = "";
        message.pointsNeeded = "";
        message.released = false;
        message.createdAt = 0;
        message.releasedAt = 0;
        message.reviewVideoUrl = "";
        message.reviewCreatedAt = 0;
        message.reviewApproved = false;
        if (value !== undefined)
            reflectionMergePartial<GiftShop_Card>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftShop_Card): GiftShop_Card {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                case /* string title */ 2:
                    message.title = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* string image_src */ 4:
                    message.imageSrc = reader.string();
                    break;
                case /* string usdt_price */ 5:
                    message.usdtPrice = reader.string();
                    break;
                case /* string usdt_fee */ 6:
                    message.usdtFee = reader.string();
                    break;
                case /* string points_needed */ 7:
                    message.pointsNeeded = reader.string();
                    break;
                case /* bool released */ 8:
                    message.released = reader.bool();
                    break;
                case /* uint32 created_at */ 9:
                    message.createdAt = reader.uint32();
                    break;
                case /* uint32 released_at */ 10:
                    message.releasedAt = reader.uint32();
                    break;
                case /* mlmbox.types.Wallet.Asset.Transaction transaction */ 11:
                    message.transaction = Wallet_Asset_Transaction.internalBinaryRead(reader, reader.uint32(), options, message.transaction);
                    break;
                case /* string review_video_url */ 12:
                    message.reviewVideoUrl = reader.string();
                    break;
                case /* uint32 review_created_at */ 13:
                    message.reviewCreatedAt = reader.uint32();
                    break;
                case /* bool review_approved */ 14:
                    message.reviewApproved = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftShop_Card, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        /* string title = 2; */
        if (message.title !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.title);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* string image_src = 4; */
        if (message.imageSrc !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.imageSrc);
        /* string usdt_price = 5; */
        if (message.usdtPrice !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.usdtPrice);
        /* string usdt_fee = 6; */
        if (message.usdtFee !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.usdtFee);
        /* string points_needed = 7; */
        if (message.pointsNeeded !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.pointsNeeded);
        /* bool released = 8; */
        if (message.released !== false)
            writer.tag(8, WireType.Varint).bool(message.released);
        /* uint32 created_at = 9; */
        if (message.createdAt !== 0)
            writer.tag(9, WireType.Varint).uint32(message.createdAt);
        /* uint32 released_at = 10; */
        if (message.releasedAt !== 0)
            writer.tag(10, WireType.Varint).uint32(message.releasedAt);
        /* mlmbox.types.Wallet.Asset.Transaction transaction = 11; */
        if (message.transaction)
            Wallet_Asset_Transaction.internalBinaryWrite(message.transaction, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        /* string review_video_url = 12; */
        if (message.reviewVideoUrl !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.reviewVideoUrl);
        /* uint32 review_created_at = 13; */
        if (message.reviewCreatedAt !== 0)
            writer.tag(13, WireType.Varint).uint32(message.reviewCreatedAt);
        /* bool review_approved = 14; */
        if (message.reviewApproved !== false)
            writer.tag(14, WireType.Varint).bool(message.reviewApproved);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GiftShop.Card
 */
export const GiftShop_Card = new GiftShop_Card$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftShop_Card_Id$Type extends MessageType<GiftShop_Card_Id> {
    constructor() {
        super("mlmbox.types.GiftShop.Card.Id", [
            { no: 1, name: "id", kind: "scalar", T: 13 /*ScalarType.UINT32*/ }
        ]);
    }
    create(value?: PartialMessage<GiftShop_Card_Id>): GiftShop_Card_Id {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = 0;
        if (value !== undefined)
            reflectionMergePartial<GiftShop_Card_Id>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftShop_Card_Id): GiftShop_Card_Id {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 id */ 1:
                    message.id = reader.uint32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftShop_Card_Id, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).uint32(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GiftShop.Card.Id
 */
export const GiftShop_Card_Id = new GiftShop_Card_Id$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftShop_Info$Type extends MessageType<GiftShop_Info> {
    constructor() {
        super("mlmbox.types.GiftShop.Info", [
            { no: 1, name: "points_balance_frozen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "points_balance_available", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "need_review_card_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 4, name: "card", kind: "message", T: () => GiftShop_Card }
        ]);
    }
    create(value?: PartialMessage<GiftShop_Info>): GiftShop_Info {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pointsBalanceFrozen = "";
        message.pointsBalanceAvailable = "";
        message.needReviewCardIds = [];
        if (value !== undefined)
            reflectionMergePartial<GiftShop_Info>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftShop_Info): GiftShop_Info {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string points_balance_frozen */ 1:
                    message.pointsBalanceFrozen = reader.string();
                    break;
                case /* string points_balance_available */ 2:
                    message.pointsBalanceAvailable = reader.string();
                    break;
                case /* repeated uint32 need_review_card_ids */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.needReviewCardIds.push(reader.uint32());
                    else
                        message.needReviewCardIds.push(reader.uint32());
                    break;
                case /* mlmbox.types.GiftShop.Card card */ 4:
                    message.card = GiftShop_Card.internalBinaryRead(reader, reader.uint32(), options, message.card);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftShop_Info, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string points_balance_frozen = 1; */
        if (message.pointsBalanceFrozen !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pointsBalanceFrozen);
        /* string points_balance_available = 2; */
        if (message.pointsBalanceAvailable !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pointsBalanceAvailable);
        /* repeated uint32 need_review_card_ids = 3; */
        if (message.needReviewCardIds.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.needReviewCardIds.length; i++)
                writer.uint32(message.needReviewCardIds[i]);
            writer.join();
        }
        /* mlmbox.types.GiftShop.Card card = 4; */
        if (message.card)
            GiftShop_Card.internalBinaryWrite(message.card, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GiftShop.Info
 */
export const GiftShop_Info = new GiftShop_Info$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GiftShop_State$Type extends MessageType<GiftShop_State> {
    constructor() {
        super("mlmbox.types.GiftShop.State", [
            { no: 1, name: "points_balance_frozen", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "points_balance_available", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "settings_card_usdt_price_min", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "need_review_card_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 13 /*ScalarType.UINT32*/ },
            { no: 5, name: "cards", kind: "message", repeat: 1 /*RepeatType.PACKED*/, T: () => GiftShop_Card }
        ]);
    }
    create(value?: PartialMessage<GiftShop_State>): GiftShop_State {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pointsBalanceFrozen = "";
        message.pointsBalanceAvailable = "";
        message.settingsCardUsdtPriceMin = "";
        message.needReviewCardIds = [];
        message.cards = [];
        if (value !== undefined)
            reflectionMergePartial<GiftShop_State>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GiftShop_State): GiftShop_State {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string points_balance_frozen */ 1:
                    message.pointsBalanceFrozen = reader.string();
                    break;
                case /* string points_balance_available */ 2:
                    message.pointsBalanceAvailable = reader.string();
                    break;
                case /* string settings_card_usdt_price_min */ 3:
                    message.settingsCardUsdtPriceMin = reader.string();
                    break;
                case /* repeated uint32 need_review_card_ids */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.needReviewCardIds.push(reader.uint32());
                    else
                        message.needReviewCardIds.push(reader.uint32());
                    break;
                case /* repeated mlmbox.types.GiftShop.Card cards */ 5:
                    message.cards.push(GiftShop_Card.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GiftShop_State, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string points_balance_frozen = 1; */
        if (message.pointsBalanceFrozen !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.pointsBalanceFrozen);
        /* string points_balance_available = 2; */
        if (message.pointsBalanceAvailable !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pointsBalanceAvailable);
        /* string settings_card_usdt_price_min = 3; */
        if (message.settingsCardUsdtPriceMin !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.settingsCardUsdtPriceMin);
        /* repeated uint32 need_review_card_ids = 4; */
        if (message.needReviewCardIds.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.needReviewCardIds.length; i++)
                writer.uint32(message.needReviewCardIds[i]);
            writer.join();
        }
        /* repeated mlmbox.types.GiftShop.Card cards = 5; */
        for (let i = 0; i < message.cards.length; i++)
            GiftShop_Card.internalBinaryWrite(message.cards[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message mlmbox.types.GiftShop.State
 */
export const GiftShop_State = new GiftShop_State$Type();
